import { authPost } from '../http_client.js';
import type { AppsFlyerAttributionRequest } from '../dto/appsflyer_attribution.dto.js';

export async function sendAppsFlyerAttribution(
  payload: AppsFlyerAttributionRequest
): Promise<{ content_mode: string | null }>
{
  return authPost<{ content_mode: string | null }>( 'api/player/me/appsflyer-attribution', payload );
}
